import React from "react";
import DialogList from "../SecComponents/dialogList";

const availableReferences = {
  message: "Por favor, indique alguna de las referencias:",
  optionList: ["No. Solicitud"],
};

function AduanaDocumentos() {
  return (
    <div>
      <DialogList references={availableReferences} />
    </div>
  );
}

export default AduanaDocumentos;
